<template>
  <div
    class="constrain text-center max-w-5xl m-auto pt-6 lg:pt-24 text-black-mid pl-10 pr-10"
  >
    <h1 class="heading-1">Contact Us</h1>
    <p class="text-xl mt-6 text-grey-dark">Operating hours</p>
    <h2 class="text-3xl font-bold mt-4">
      Monday - Friday, 09:00 - 17:00
    </h2>
  </div>

  <div class="w-full p-6 lg:p-20 mt-10">
    <div
      class="lg:flex lg:space-x-6 space-y-6 lg:space-y-0 max-w-7xl m-auto"
    >
      <div
        class="flex items-start lg:w-1/3 space-x-5 rounded-3xl bg-white border border-grey-2 p-6"
      >
        <div class="bg-[#DCFBEA] p-6 rounded-md">
          <PhoneIcon class="w-8 h-8" />
        </div>
        <div>
          <h3 class="mb-2 font-semibold text-xl">Call us</h3>
          <p class="text-lg mb-4">
            Give us a call, one of our friendly team members will be
            able to help
          </p>
          <a href="tel:08081968031"
             class="font-bold cursor-pointer text-primary text-xl"
          >
            0808 196 8031
          </a>
        </div>
      </div>
      <div
        class="flex items-start lg:w-1/3 space-x-5 rounded-3xl bg-white border border-grey-2 p-6"
      >
        <div class="bg-[#DCFBEA] p-6 rounded-md">
          <ChatBubbleBottomCenterTextIcon class="w-8 h-8" />
        </div>
        <div>
          <h3 class="mb-2 font-semibold text-xl">Live Chat</h3>
          <p class="text-lg">
            Get a quote for a skip or speak to a member of our team
            today.
          </p>
          <Button
            id="openLiveChatBtn"
            @click="openLiveChat()"
            size="lg" class="mt-3"
          >
            Open Live Chat
          </Button>
        </div>
      </div>
      <div
        class="flex items-start lg:w-1/3 space-x-5 rounded-3xl bg-white border border-grey-2 p-6"
      >
        <div class="bg-[#DCFBEA] p-6 rounded-md">
          <EnvelopeIcon class="w-8 h-8" />
        </div>
        <div>
          <h3 class="mb-2 font-semibold text-xl">Message us</h3>
          <p class="text-lg">
            Send us a message using our form, we'll get back to you
            asap.
          </p>
          <ContactForm/>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center space-y-6 mb-10 px-10">
    <h2 class="subtitle-1">Find answers</h2>
    <p class="text-grey-dark">Check our Knowledge base to find the answers to your questions by checking our handy guides.</p>
    <Button as="nuxt-link" intent="secondary" to="/knowledge">
      View knowledge base
    </Button>
  </div>

  <LiveChatWidget license="14102010" />
</template>
<script setup>
import {
  PhoneIcon,
  ChatBubbleBottomCenterTextIcon,
  EnvelopeIcon,
} from "@heroicons/vue/24/outline";
import {LiveChatWidget} from "@livechat/widget-vue";

function openLiveChat() {
  window.LiveChatWidget.call("maximize");
}

const canonical = computed(() => {
  return 'https://justhire.com/contact-us';
});

const ogImage = computed(() => {
  return 'https://justhire.com/og-image.webp';
});

useHead({
  link: [
    { rel: 'canonical', href: canonical.value },
  ],
});

useSeoMeta({
  title: () => "Contact JustHire",
  description: () =>
    "Contact JustHire by phone, email or live chat, we're always here to help",
  // Open Graph
  ogTitle: () => 'Contact JustHire',
  ogDescription: () => 'Contact JustHire by phone, email or live chat, we\'re always here to help',
  ogImage: () => ogImage.value,
  ogUrl: () => canonical.value,
  ogType: 'website',
  ogSiteName: 'JUSTHIRE',
  // Twitter
  twitterTitle: () => 'Contact JustHire',
  twitterDescription: () => 'Contact JustHire by phone, email or live chat, we\'re always here to help',
  twitterImage: () => ogImage.value,
  twitterCard: 'summary_large_image',
  twitterSite: '@justhire',
});
</script>
